module.exports = __webpack_public_path__ + "img/99.f6fb9e71.jpg";